import { EActivityType, EProblemReportStatus } from '@constants';

export const ProblemReportsTranslations = {
  INCIDENTS: {
    es: 'Incidencias',
    en: 'Incidents',
    cat: 'Incidències',
    eus: 'Incidenteak',
    pt: 'Incidentes'
  },
  INCIDENTS_DESCRIPTION: {
    es: 'Problemas reportados por los alumnos en actividades y tests.',
    en: 'Problems reported by students in activities and tests.',
    cat: 'Problemes reportats per als alumnes en activitats i tests.',
    eus: 'Eskolaekoek argibideak emandako arazoak.',
    pt: 'Problemas reportados por alunos em atividades e testes.'
  },
  INCIDENTS_DESCRIPTION_TEACHER: {
    es: 'Problemas reportados por los alumnos al realizar actividades y tests de los cursos que impartes.',
    en: 'Problems reported by students when completing activities and tests in the courses you teach.',
    cat: 'Problemes reportats pels alumnes en realitzar activitats i tests dels cursos que imparteixes.',
    eus: 'Ikasleek zure ikastaroetako jardueretan eta testetan jakinarazitako arazoak.',
    pt: 'Problemas reportados por alunos ao realizar atividades e testes dos cursos que você leciona.'
  },
  PROBLEM_REPORTS_TOTAL: {
    es: 'Total {{total}}',
    en: 'Total {{total}}',
    cat: 'Total {{total}}',
    eus: 'Total {{total}}',
    pt: 'Total {{total}}'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Titulazioa',
    pt: 'Título'
  },
  [EProblemReportStatus.REVIEWED]: {
    es: 'Resueltas',
    en: 'Resolved',
    cat: 'Resoltes',
    eus: 'Ebaztuta',
    pt: 'Resolvidas'
  },
  [EProblemReportStatus.IN_REVIEW]: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Berrikuspenan',
    pt: 'Em revisão'
  },
  [EProblemReportStatus.NOT_REVIEWED]: {
    es: 'Sin revisar',
    en: 'Without review',
    cat: 'Sense revisar',
    eus: 'Ez da berrikuspenik',
    pt: 'Sem revisão'
  },
  ALL_STATUS: {
    es: 'Todas',
    en: 'All',
    cat: 'Totes',
    eus: 'Denak',
    pt: 'Todas'
  },
  OPEN_PROBLEM_REPORTS: {
    es: 'Abiertas',
    en: 'Open',
    cat: 'Oberta',
    eus: 'Irekita',
    pt: 'Aberta'
  },
  NO_PROBLEM_REPORTS: {
    es: 'No hay incidencias reportadas',
    en: 'No reported incidents',
    cat: 'No hi ha incidències reportades',
    eus: 'Ez da argibideak emandako',
    pt: 'Não há incidentes reportados'
  },
  NO_PROBLEM_REPORTS_DESCRIPTION: {
    es: 'Cuando los alumnos reporten problemas, aparecerán aquí.',
    en: 'When students report problems, they will appear here.',
    cat: 'Quan els alumnes reporten problemes, apareixeran aquí.',
    eus: 'Ikasleek arazoak emandakoan, hemen agertuko dira.',
    pt: 'Quando os alunos reportarem problemas, aparecerão aqui.'
  },
  NO_SOLVED_PROBLEM_REPORTS: {
    es: 'Aún no hay incidencias resueltas',
    en: 'No resolved incidents',
    cat: 'No incidències resoltes',
    eus: 'Ez da argibideak ebaztuta',
    pt: 'Não há incidentes resolvidos'
  },
  NO_SOLVED_PROBLEM_REPORTS_DESCRIPTION: {
    es: 'Las incidencias aparecerán aquí cuando se marquen como resueltas.',
    en: 'The incidents will appear here when they are marked as resolved.',
    cat: 'Les incidències apareixeran aquí quan es marquin com a resoltes.',
    eus: 'Argibideak hemen agertuko dira ebaztuta daudenean.',
    pt: 'As incidencias aparecerão aqui quando forem marcadas como resolvidas.'
  },
  NO_OPEN_PROBLEM_REPORTS: {
    es: 'No hay incidencias abiertas',
    en: 'No open incidents',
    cat: 'No incidències obertes',
    eus: 'Ez da argibideak ireki',
    pt: 'Não há incidentes abertos'
  },
  NO_OPEN_PROBLEM_REPORTS_DESCRIPTION: {
    es: 'Todas las incidencias están resueltas.',
    en: 'All incidents are resolved.',
    cat: 'Totes les incidències estan resoltes.',
    eus: 'Denak argibideak ebaztuta daude.',
    pt: 'Todos os incidentes estão resolvidos.'
  },
  NO_PROBLEM_REPORTS_FILTERED: {
    es: 'No hay incidencias con estos filtros',
    en: 'No incidents with these filters',
    cat: 'No incidències amb aquests filtres',
    eus: 'Ez da argibideak hauetatik iragazkiak',
    pt: 'Não há incidentes com esses filtros'
  },
  NO_PROBLEM_REPORTS_FILTERED_DESCRIPTION: {
    es: 'Prueba a cambiar los filtros o la búsqueda.',
    en: 'Try changing the filters or the search.',
    cat: 'Prova de canviar els filtres o la cerca.',
    eus: 'Iragazkiak aldatu edo bilaketa aldatu.',
    pt: 'Tente alterar os filtros ou a pesquisa.'
  },
  DRAWER_TITLE: {
    es: 'Incidencia en {{resourceType}}',
    en: 'Incidence in {{resourceType}}',
    cat: 'Incidència en {{resourceType}}',
    eus: 'Argibidea {{resourceType}}',
    pt: 'Incidência em {{resourceType}}'
  },
  LOADING_TITLE: {
    es: 'Cargando incidencia...',
    en: 'Loading incident...',
    cat: 'Carregant incidència...',
    eus: 'Argibidea kargatzen...',
    pt: 'Carregando incidência...'
  },
  RESOLVE_MODAL_TITLE: {
    es: '¿Incidencia resuelta? Notifica al alumno',
    en: 'Incident resolved? Notify the student',
    cat: "Incidència resolta? Notifica l'alumne",
    eus: 'Argibidea ebatzita? Jakinarazi ikasleari',
    pt: 'Incidência resolvida? Notifique o aluno'
  },
  RESOLVE_MODAL_DESCRIPTION: {
    es: 'Puedes enviarle un mensaje personalizado al alumno explicando qué se ha hecho o dándole más indicaciones.',
    en: 'You can send a personalized message to the student explaining what has been done or giving more instructions.',
    cat: "Pots enviar-li un missatge personalitzat a l'alumne explicant què s'ha fet o donant-li més indicacions.",
    eus: 'Mezu pertsonalizatua bidali dezakezu ikasleari egindakoa azalduz edo argibide gehiago emanez.',
    pt: 'Você pode enviar uma mensagem personalizada ao aluno explicando o que foi feito ou dando mais instruções.'
  },
  RESOLVE_MODAL_SEND_TO: {
    es: 'Enviar mensaje a {{userName}}',
    en: 'Send message to {{userName}}',
    cat: 'Enviar missatge a {{userName}}',
    eus: 'Bidali mezua {{userName}}-ri',
    pt: 'Enviar mensagem para {{userName}}'
  },
  RESOLVE_MODAL_DEFAULT_MESSAGE: {
    es: '¡Hola!\nHemos revisado la incidencia que reportaste en {{activityName}} y ya está resuelta.\nGracias por avisarnos 🙂\nSi detectas cualquier otro problema, no dudes en escribirnos.',
    en: 'Hello!\nWe have reviewed the incident you reported in {{activityName}} and it has been resolved.\nThank you for letting us know 🙂\nIf you detect any other problem, do not hesitate to write to us.',
    cat: "Hola!\nHem revisat la incidència que vas reportar a {{activityName}} i ja està resolta.\nGràcies per avisar-nos 🙂\nSi detectes qualsevol altre problema, no dubtis en escriure'ns.",
    eus: 'Kaixo!\n{{activityName}}-n jakinarazi zenuen arazoa berrikusi dugu eta dagoeneko ebatzita dago.\nEskerrik asko jakinarazteagatik 🙂\nBeste edozein arazo antzematen baduzu, ez zalantzatu gurekin harremanetan jartzeko.',
    pt: 'Olá!\nRevisamos a incidência que você reportou em {{activityName}} e já está resolvida.\nObrigado por nos avisar 🙂\nSe detectar qualquer outro problema, não hesite em nos escrever.'
  },
  RESOLVE_MODAL_EDITABLE_HINT: {
    es: 'Este mensaje es editable. Puedes cambiarlo antes de enviarlo.',
    en: 'This message is editable. You can change it before sending.',
    cat: "Aquest missatge és editable. Pots canviar-lo abans d'enviar-lo.",
    eus: 'Mezu hau editagarria da. Bidali aurretik aldatu dezakezu.',
    pt: 'Esta mensagem é editável. Você pode alterá-la antes de enviar.'
  },
  RESOLVE_MODAL_CONFIRM_BUTTON: {
    es: 'Resolver y enviar mensaje',
    en: 'Resolve and send message',
    cat: 'Resoldre i enviar missatge',
    eus: 'Ebatzi eta mezua bidali',
    pt: 'Resolver e enviar mensagem'
  },
  RESOLVE_MODAL_CANCEL_TITLE: {
    es: '¿Salir sin resolver?',
    en: 'Leave without resolving?',
    cat: 'Sortir sense resoldre?',
    eus: 'Irten ebatzi gabe?',
    pt: 'Sair sem resolver?'
  },
  RESOLVE_MODAL_CANCEL_CONTENT: {
    es: 'Si sales ahora, la incidencia no se marcará como resuelta y no se enviará el mensaje al alumno.',
    en: 'If you leave now, the incident will not be marked as resolved and the message will not be sent to the student.',
    cat: "Si surts ara, la incidència no es marcarà com a resolta i no s'enviarà el missatge a l'alumne.",
    eus: 'Orain irteten bazara, arazoa ez da ebatzitako gisa markatuko eta mezua ez zaio ikasleari bidaliko.',
    pt: 'Se você sair agora, a incidência não será marcada como resolvida e a mensagem não será enviada ao aluno.'
  },
  RESOLVE_MODAL_CANCEL_STAY: {
    es: 'Continuar editando',
    en: 'Continue editing',
    cat: 'Continuar editant',
    eus: 'Jarraitu editatzen',
    pt: 'Continuar editando'
  },
  RESOLVE_MODAL_CANCEL_LEAVE: {
    es: 'Salir sin resolver',
    en: 'Leave without resolving',
    cat: 'Sortir sense resoldre',
    eus: 'Irten ebatzi gabe',
    pt: 'Sair sem resolver'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  REPORTED_BY: {
    es: 'Reportado por',
    en: 'Reported by',
    cat: 'Reportat per',
    eus: 'Txostenak',
    pt: 'Relatórios'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  CREATED_AT: {
    es: 'Fecha de creación',
    en: 'Creation date',
    cat: 'Data de creació',
    eus: 'Sortze data',
    pt: 'Data de criação'
  },
  CREATION_DATE: {
    es: 'Creación',
    en: 'Creation',
    cat: 'Creació',
    eus: 'Sortze data',
    pt: 'Data de criação'
  },
  TOTAL_REPORTS: {
    es: 'Total reportes',
    en: 'Total reports',
    cat: 'Total informes',
    eus: 'Txosten guztira',
    pt: 'Total relatórios'
  },
  LAST_REPORT_DATE: {
    es: 'Último reporte',
    en: 'Last report',
    cat: 'Últim informe',
    eus: 'Azken txostena',
    pt: 'Último relatório'
  },
  WARNING_14_DAYS: {
    es: 'Hay reportes sin revisar desde hace más de 14 días',
    en: 'There are unreviewed reports for more than 14 days',
    cat: 'Hi ha informes sense revisar des de fa més de 14 dies',
    eus: 'Berrikusi gabeko txostenak daude 14 egun baino gehiago',
    pt: 'Há relatórios não revisados há mais de 14 dias'
  },
  WARNING_30_DAYS: {
    es: 'Urgente: hay reportes sin revisar desde hace más de 30 días',
    en: 'Urgent: there are unreviewed reports for more than 30 days',
    cat: 'Urgent: hi ha informes sense revisar des de fa més de 30 dies',
    eus: 'Urgentea: berrikusi gabeko txostenak daude 30 egun baino gehiago',
    pt: 'Urgente: há relatórios não revisados há mais de 30 dias'
  },
  AGO_MINUTES: {
    es: 'Hace {{count}} min',
    en: '{{count}} min ago',
    cat: 'Fa {{count}} min',
    eus: 'Duela {{count}} min',
    pt: 'Há {{count}} min'
  },
  AGO_HOURS: {
    es: 'Hace {{count}} h',
    en: '{{count}} h ago',
    cat: 'Fa {{count}} h',
    eus: 'Duela {{count}} h',
    pt: 'Há {{count}} h'
  },
  AGO_DAYS: {
    es: 'Hace {{count}} días',
    en: '{{count}} days ago',
    cat: 'Fa {{count}} dies',
    eus: 'Duela {{count}} egun',
    pt: 'Há {{count}} dias'
  },
  AGO_MONTHS: {
    es: 'Hace {{count}} meses',
    en: '{{count}} months ago',
    cat: 'Fa {{count}} mesos',
    eus: 'Duela {{count}} hilabete',
    pt: 'Há {{count}} meses'
  },
  REPORT_SENT_SUCCESSFULLY: {
    es: 'Hemos recibido tu reporte y estamos trabajando para resolver el problema lo antes posible.',
    en: 'We have received your report and are working to resolve the issue as soon as possible.',
    cat: 'Hem rebut la teva informació i estem treballant per resoldre el problema el més aviat possible.',
    eus: 'Jaso dugu zure txostena eta aprobetxatzen ari gara arazoak azkartu dezaten.',
    pt: 'Recebemos seu relatório e estamos trabalhando para resolver o problema o mais rápido possível.'
  },
  STATUS_SUCCESSFULLY_UPDATED: {
    es: 'El estado del reporte se ha actualizado correctamente.',
    en: 'The status of the report has been updated correctly.',
    cat: "L'estat del reporti s'ha actualitzat correctament.",
    eus: 'Txostenaren egoera behar bezala eguneratu da.',
    pt: 'O estado do relatório foi atualizado com sucesso.'
  },
  QUESTION_TITLE: {
    es: 'Título pregunta',
    en: 'Question title',
    cat: 'Títol de la pregunta',
    eus: 'Galderaren titulua',
    pt: 'Título da questão'
  },
  QUESTION_ANSWERS: {
    es: 'Respuestas',
    en: 'Answers',
    cat: 'Respostes',
    eus: 'Erantzunak',
    pt: 'Respostas'
  },
  QUESTION_DETAIL: {
    es: 'Detalle pregunta',
    en: 'Question detail',
    cat: 'Detall de la pregunta',
    eus: 'Galderaren xehetasunak',
    pt: 'Detalhes da questão'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Kurtsua',
    pt: 'Curso'
  },
  SECTION: {
    es: 'Sección',
    en: 'Section',
    cat: 'Secció',
    eus: 'Atala',
    pt: 'Seção'
  },
  ACTIVITY_NAME: {
    es: 'Nombre actividad',
    en: 'Activity name',
    cat: "Nom de l'activitat",
    eus: 'Jardueraren izena',
    pt: 'Nome da atividade'
  },
  ACTIVITY_DESCRIPTION: {
    es: 'Descripción actividad',
    en: 'Activity description',
    cat: "Descripció de l'activitat",
    eus: 'Jardueraren deskribapena',
    pt: 'Descrição da atividade'
  },
  COURSE_DETAIL: {
    es: 'Detalle del curso',
    en: 'Course detail',
    cat: 'Detall del curs',
    eus: 'Kurtsuaren xehetasunak',
    pt: 'Detalhes do curso'
  },
  REPORT_DELETED_SUCCESSFULLY: {
    es: 'El reporte se ha eliminado correctamente.',
    en: 'The report has been deleted correctly.',
    cat: "El reporti s'ha eliminat correctament.",
    eus: 'Txostena behar bezala ezabatu da.',
    pt: 'O relatório foi excluído com sucesso.'
  },
  DELETE_REPORT: {
    es: 'Eliminar reporte',
    en: 'Delete report',
    cat: 'Eliminar reporti',
    eus: 'Txostena ezabatu',
    pt: 'Excluir relatório'
  },
  DELETE_REPORT_CONFIRMATION: {
    es: '¿Estás seguro de que quieres eliminar estos reportes? Esta acción no se puede deshacer.',
    en: 'Are you sure you want to delete these reports? This action cannot be undone.',
    cat: '¿Estàs segur que vols eliminar aquests reportis? Aquesta acció no es pot desfer.',
    eus: '¿Ziur zaude txosten hauek ezabatu nahi dituzula? Ekintza hau ezin da desegin.',
    pt: 'Tem certeza que deseja excluir estes relatórios? Esta ação não pode ser desfeita.'
  },
  DELETE: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Excluir'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezeztatu',
    pt: 'Cancelar'
  },
  TYPE: {
    es: 'Tipo',
    en: 'Type',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipo'
  },
  ACTIVITY: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Jarduerak',
    pt: 'Atividades'
  },
  QUESTION: {
    es: 'Pregunta',
    en: 'Question',
    cat: 'Pregunta',
    eus: 'Galdera',
    pt: 'Questão'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Iragazkiak',
    pt: 'Filtros'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Tags',
    cat: 'Formacions',
    eus: 'Formakuntzak',
    pt: 'Formações'
  },
  SELECT_A_TAG_TO_FILTER: {
    es: 'Selecciona una formación',
    en: 'Select a tag',
    cat: 'Selecciona una formació',
    eus: 'Hautatu formakuntza bat',
    pt: 'Selecione uma formação'
  },
  PROBLEM_REPORT_NOT_FOUND: {
    es: 'No se ha encontrado el recurso asociado al reporte de problema. Por favor, borra este reporte.',
    en: 'The resource associated with the problem report was not found. Please delete this report.',
    cat: "No s'ha trobat el recurs associat al reporti de problema. Si us plau, esborra aquest reporti.",
    eus: 'Ez da aurkitu arazoaren txostenarekin erlazionatutako baliabidea. Mesedez, ezabatu txostena hau.',
    pt: 'Não foi encontrado o recurso associado ao relatório de problema. Por favor, exclua este relatório.'
  },
  [EActivityType.VIDEO]: {
    es: 'Video',
    en: 'Video',
    cat: 'Vídeo',
    eus: 'Bideoa',
    pt: 'Vídeo'
  },
  [EActivityType.PDF]: {
    es: 'PDF',
    en: 'PDF',
    cat: 'PDF',
    eus: 'PDF',
    pt: 'PDF'
  },
  [EActivityType.DELIVERABLE]: {
    es: 'Entregable',
    en: 'Deliverable',
    cat: 'Lliurament',
    eus: 'Entregaketa',
    pt: 'Entrega'
  },
  [EActivityType.QUIZ]: {
    es: 'Test',
    en: 'Quiz',
    cat: 'Test',
    eus: 'Test',
    pt: 'Teste'
  },
  [EActivityType.TEXT]: {
    es: 'Texto',
    en: 'Text',
    cat: 'Text',
    eus: 'Testua',
    pt: 'Texto'
  },
  DATE_FILTER_ALL: {
    es: 'Todas las fechas',
    en: 'All dates',
    cat: 'Totes les dates',
    eus: 'Data guztiak',
    pt: 'Todas as datas'
  },
  DATE_FILTER_LAST_7_DAYS: {
    es: 'Últimos 7 días',
    en: 'Last 7 days',
    cat: 'Últims 7 dies',
    eus: 'Azken 7 egunak',
    pt: 'Últimos 7 dias'
  },
  DATE_FILTER_LAST_30_DAYS: {
    es: 'Últimos 30 días',
    en: 'Last 30 days',
    cat: 'Últims 30 dies',
    eus: 'Azken 30 egunak',
    pt: 'Últimos 30 dias'
  },
  DATE_FILTER_THIS_MONTH: {
    es: 'Este mes',
    en: 'This month',
    cat: 'Aquest mes',
    eus: 'Hilabete hau',
    pt: 'Este mês'
  },
  DATE_FILTER_THIS_QUARTER: {
    es: 'Este trimestre',
    en: 'This quarter',
    cat: 'Aquest trimestre',
    eus: 'Hiruhileko hau',
    pt: 'Este trimestre'
  },
  DATE_FILTER_THIS_YEAR: {
    es: 'Este año',
    en: 'This year',
    cat: 'Aquest any',
    eus: 'Urte hau',
    pt: 'Este ano'
  },
  DATE_FILTER_CUSTOM_RANGE: {
    es: 'Rango de fechas',
    en: 'Date range',
    cat: 'Rang de dates',
    eus: 'Data tartea',
    pt: 'Intervalo de datas'
  },
  START_DATE: {
    es: 'Fecha inicio',
    en: 'Start date',
    cat: 'Data inici',
    eus: 'Hasiera data',
    pt: 'Data início'
  },
  END_DATE: {
    es: 'Fecha fin',
    en: 'End date',
    cat: 'Data fi',
    eus: 'Amaiera data',
    pt: 'Data fim'
  },
  REPORT_STATUS: {
    es: 'Estado reporte',
    en: 'Report status',
    cat: 'Estat reporti',
    eus: 'Txostenaren egoera',
    pt: 'Estado do relatório'
  },
  REPORT_STATUS_NOT_REVIEWED: {
    es: 'Sin revisar',
    en: 'Not reviewed',
    cat: 'Sense revisar',
    eus: 'Berrikusi gabe',
    pt: 'Não revisado'
  },
  REPORT_STATUS_IN_REVIEW: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Berrikuspenean',
    pt: 'Em revisão'
  },
  SORT_BY_TOTAL_REPORTS: {
    es: 'Ordenar por número total de reportes',
    en: 'Sort by total number of reports',
    cat: 'Ordenar per nombre total de reportis',
    eus: 'Ordenatu txosten kopuru osoaren arabera',
    pt: 'Ordenar por número total de relatórios'
  },
  SORT_BY_NOT_REVIEWED: {
    es: 'Ordenar por número de reportes sin revisar',
    en: 'Sort by number of unreviewed reports',
    cat: 'Ordenar per nombre de reportis sense revisar',
    eus: 'Ordenatu berrikusi gabeko txostenen arabera',
    pt: 'Ordenar por número de relatórios não revisados'
  },
  SORT_BY_IN_REVIEW: {
    es: 'Ordenar por número de reportes en revisión',
    en: 'Sort by number of reports in review',
    cat: 'Ordenar per nombre de reportis en revisió',
    eus: 'Ordenatu berrikuspenean dauden txostenen arabera',
    pt: 'Ordenar por número de relatórios em revisão'
  },
  SORT_BY_REVIEWED: {
    es: 'Ordenar por número de reportes resueltos',
    en: 'Sort by number of resolved reports',
    cat: 'Ordenar per nombre de reportis resolts',
    eus: 'Ordenatu konpondutako txostenen arabera',
    pt: 'Ordenar por número de relatórios resolvidos'
  },
  SORT_BY_CREATION_DATE: {
    es: 'Ordenar por fecha de creación',
    en: 'Sort by creation date',
    cat: 'Ordenar per data de creació',
    eus: 'Ordenatu sortze-dataren arabera',
    pt: 'Ordenar por data de criação'
  },
  SORT_ASC: {
    es: 'Ordenar de menor a mayor',
    en: 'Sort ascending',
    cat: 'Ordenar de menor a major',
    eus: 'Ordenatu txikitik handira',
    pt: 'Ordenar de menor a maior'
  },
  SORT_DESC: {
    es: 'Ordenar de mayor a menor',
    en: 'Sort descending',
    cat: 'Ordenar de major a menor',
    eus: 'Ordenatu handitik txikira',
    pt: 'Ordenar de maior a menor'
  },
  SORT_CREATION_DATE_ASC: {
    es: 'Ordenar por fecha de creación de más antigua a más reciente',
    en: 'Sort by creation date from oldest to newest',
    cat: 'Ordenar per data de creació de més antiga a més recent',
    eus: 'Ordenatu sortze-dataren arabera zaharrenetik berrienetara',
    pt: 'Ordenar por data de criação da mais antiga para a mais recente'
  },
  SORT_CREATION_DATE_DESC: {
    es: 'Ordenar por fecha de creación de más reciente a más antigua',
    en: 'Sort by creation date from newest to oldest',
    cat: 'Ordenar per data de creació de més recent a més antiga',
    eus: 'Ordenatu sortze-dataren arabera berrienetik zaharrenetara',
    pt: 'Ordenar por data de criação da mais recente para a mais antiga'
  },
  DOWNLOAD_CSV: {
    es: 'Descargar CSV',
    en: 'Download CSV',
    cat: 'Descarregar CSV',
    eus: 'Deskargatu CSV',
    pt: 'Baixar CSV'
  }
};
